import React, {Component} from 'react';
import {Mutation} from 'react-apollo'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import NotificationList from './NotificationList'

import mutation from '../../../queries/server/mutations/update_user_viewed_notifications'
import query from '../../../queries/server/notifications'

class NotificationModal extends Component {

  componentDidMount(){
    console.log('subscribed to upsert')
    this.props.subscribeToUpsert()
  }

  render() {

    const {data, isOpen, office_id} = this.props

    if(!data || data.length === 0) return null

    return (
      <Mutation 
        mutation={mutation}
        update={(cache, {data: {updateViewedNotificationsAt}}) => {
          const {me, notifications} = cache.readQuery({query, variables: {office_id}})
          cache.writeQuery({
            query,
            data: {me: {...me, ...updateViewedNotificationsAt}, notifications}
          })
        }}
        >
        {(func, {loading}) => {
          return (
            <Modal isOpen={isOpen} size="lg">
                <ModalHeader>Notifications</ModalHeader>
                <ModalBody>
                  <NotificationList data={data}/>
                </ModalBody>
                <ModalFooter>
                <Button
                  size="sm"
                  color="primary"
                  onClick={() => func()}
                >
                    <FontAwesomeIcon color="#fff"
                                      icon={loading ? 'spinner' : 'check'}/>{' '}
                    OK
                </Button>
                </ModalFooter>
            </Modal>
          )
        }}
      </Mutation>
    )
  }
}

export default NotificationModal